import { angularAMD } from "@pebblepad/amd";
import "../multiLanguageService/multiLanguageService";

angularAMD.factory("datePickerHelper", [
    "multiLanguageService",
    function (multiLanguageService) {
        var datePickerHelper = {
            // internationalization
            i18n: {
                previous_month: multiLanguageService.getString("builder.datePicker.previous_month"),
                next_month: multiLanguageService.getString("builder.datePicker.next_month"),
                today: multiLanguageService.getString("builder.datePicker.today"),
                months: [
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.jan.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.jan.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.feb.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.feb.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.mar.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.mar.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.apr.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.apr.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.may.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.may.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.jun.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.jun.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.jul.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.jul.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.aug.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.aug.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.sep.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.sep.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.oct.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.oct.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.nov.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.nov.short")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.months.dec.full"),
                        short: multiLanguageService.getString("builder.datePicker.months.dec.short")
                    }
                ],
                weekdays: [
                    {
                        full: multiLanguageService.getString("builder.datePicker.weekdays.mon.full"),
                        short: multiLanguageService.getString("builder.datePicker.weekdays.mon.short"),
                        tiny: multiLanguageService.getString("builder.datePicker.weekdays.mon.tiny")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.weekdays.tue.full"),
                        short: multiLanguageService.getString("builder.datePicker.weekdays.tue.short"),
                        tiny: multiLanguageService.getString("builder.datePicker.weekdays.tue.tiny")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.weekdays.wed.full"),
                        short: multiLanguageService.getString("builder.datePicker.weekdays.wed.short"),
                        tiny: multiLanguageService.getString("builder.datePicker.weekdays.wed.tiny")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.weekdays.thu.full"),
                        short: multiLanguageService.getString("builder.datePicker.weekdays.thu.short"),
                        tiny: multiLanguageService.getString("builder.datePicker.weekdays.thu.tiny")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.weekdays.fri.full"),
                        short: multiLanguageService.getString("builder.datePicker.weekdays.fri.short"),
                        tiny: multiLanguageService.getString("builder.datePicker.weekdays.fri.tiny")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.weekdays.sat.full"),
                        short: multiLanguageService.getString("builder.datePicker.weekdays.sat.short"),
                        tiny: multiLanguageService.getString("builder.datePicker.weekdays.sat.tiny")
                    },
                    {
                        full: multiLanguageService.getString("builder.datePicker.weekdays.sun.full"),
                        short: multiLanguageService.getString("builder.datePicker.weekdays.sun.short"),
                        tiny: multiLanguageService.getString("builder.datePicker.weekdays.sun.tiny")
                    }
                ],
                no_time_label: multiLanguageService.getString("builder.datePicker.no_time_label")
            },

            isRTL: false,

            // show week numbers at head of row
            showWeekNumber: false,

            // first day of week (0: Sunday, 1: Monday etc)
            firstDay: 1,

            // number of years either side, or array of upper/lower range
            yearRange: 10,

            // used internally (don't config outside)
            min_year: 0,
            max_year: 9999,
            min_month: undefined,
            max_month: undefined,

            /**
             * Function to detect whether object is empty or not
             * @param obj
             * @returns {boolean}
             */
            isEmptyObject: function (obj) {
                if (typeof obj === "object") {
                    for (var i in obj) {
                        if (obj.hasOwnProperty(i)) {
                            return false;
                        }
                    }
                    return true;
                } else {
                    return true;
                }
            },

            isArray: function (obj) {
                return /Array/.test(Object.prototype.toString.call(obj));
            },

            /**
             * Checks if object is date
             * @param obj
             * @returns {boolean}
             */
            isDate: function (obj) {
                return /Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
            },

            compareDates: function (a, b) {
                // weak date comparison (use setToStartOfDay(date) to ensure correct result)
                return this.isDate(a) && this.isDate(b) ? a.getTime() === b.getTime() : false;
            },

            isLeapYear: function (year) {
                // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
                return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
            },

            getDaysInMonth: function (year, month) {
                return [31, this.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
            },

            setToStartOfDay: function (date) {
                if (this.isDate(date)) {
                    date.setHours(0, 0, 0, 0);
                }
                return date;
            },

            setToEndOfDay: function (date) {
                if (this.isDate(date)) {
                    date.setHours(23, 59, 0, 0);
                }
                return date;
            },

            dateAdd: function (date, interval, units) {
                var ret = new Date(date); //don't change original date
                var addMethods = {
                    year: function () {
                        ret.setFullYear(ret.getFullYear() + units);
                    },
                    quarter: function () {
                        ret.setMonth(ret.getMonth() + 3 * units);
                    },
                    month: function () {
                        ret.setMonth(ret.getMonth() + units);
                    },
                    week: function () {
                        ret.setDate(ret.getDate() + 7 * units);
                    },
                    day: function () {
                        ret.setDate(ret.getDate() + units);
                    },
                    hour: function () {
                        ret.setTime(ret.getTime() + units * 3600000);
                    },
                    minute: function () {
                        ret.setTime(ret.getTime() + units * 60000);
                    },
                    second: function () {
                        ret.setTime(ret.getTime() + units * 1000);
                    },
                    default: function () {
                        ret = undefined;
                    }
                };
                (addMethods[interval] || addMethods["default"])();
                return ret;
            },

            /**
             * return a formatted string of the current selection
             */
            toString: function (date, format) {
                return !this.isDate(date) ? "" : date.format(format ?? "ddd dd-mmm-yyyy");
            },

            toUTC: function (date) {
                return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
            },

            normalizeDate: function (date, convertToUTC) {
                if (!date) {
                    return;
                }

                if (typeof date === "string" && date.indexOf("T") < 0) {
                    if (date.indexOf("Z") === -1) {
                        date += "Z";
                    }
                }

                return convertToUTC === true ? this.toUTC(new Date(date)) : new Date(date);
            },

            // TODO: REFACTOR LATER: performance is bad
            findClosestMinute: function (array, minutes, hours) {
                var i,
                    minDiff = 60,
                    ans,
                    tempDate,
                    tempDateMin;

                for (i = 0; i < array.length; i++) {
                    // tslint:disable-next-line:triple-equals
                    if (hours != 23 && i === array.length - 1) {
                        // when it's not close to midnight and last item in array force use previous item in the array for comparison
                        tempDate = new Date(array[array.length - 2].value);
                        tempDateMin = tempDate.getMinutes();
                    } else {
                        tempDate = new Date(array[i].value);
                        tempDateMin = tempDate.getMinutes();
                    }

                    var m = Math.abs(minutes - tempDateMin);

                    if (m < minDiff && tempDate.getHours() <= hours) {
                        minDiff = m;
                        ans = new Date(array[i].value).getMinutes();
                    }
                }

                return ans;
            },

            /**
             * TODO: Add disabled time when use min/max date
             * @param date
             * @param time_opts
             * @param minDate
             * @returns {string}
             */
            renderTimeDropdown: function (date, time_opts, minDate) {
                var arr = [],
                    i,
                    self = this,
                    selected,
                    option_date,
                    disabled;

                if (!date) {
                    arr.push('<option value="">' + this.i18n.no_time_label + "</option>");
                } else {
                    var adjustedDate = date;
                    var tempOrigDate = date;
                    for (i = 0; i < time_opts.length; i++) {
                        option_date = new Date(time_opts[i].value);
                        if (adjustedDate && minDate) {
                            var today = new Date();
                            tempOrigDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), option_date.getHours(), option_date.getMinutes(), 0);
                            var tempMinDate = new Date(
                                minDate.getFullYear(),
                                minDate.getMonth(),
                                minDate.getDate(),
                                minDate.getHours(),
                                minDate.getMinutes(),
                                0
                            );

                            if (
                                adjustedDate.getFullYear() === tempMinDate.getFullYear() &&
                                adjustedDate.getMonth() === tempMinDate.getMonth() &&
                                adjustedDate.getDate() === tempMinDate.getDate()
                            ) {
                                disabled = tempOrigDate <= tempMinDate ? "disabled" : "";
                            }

                            if (this.compareDates(adjustedDate, tempMinDate)) {
                                adjustedDate = this.dateAdd(new Date(date), "minute", 30);
                            }
                        }

                        /* tslint:disable:triple-equals */
                        selected =
                            option_date.getHours() == adjustedDate.getHours() &&
                            option_date.getMinutes() == self.findClosestMinute(time_opts, adjustedDate.getMinutes(), adjustedDate.getHours())
                                ? "selected"
                                : "";
                        /* tslint:enable:triple-equals */

                        arr.push('<option value="' + time_opts[i].value + '" ' + selected + " " + disabled + ">" + time_opts[i].title + "</option>");
                    }
                }

                return arr.join("");
            },

            renderCalendar: function (opts) {
                var self = this,
                    min_year = opts.min_year,
                    max_year = opts.max_year,
                    min_month = self.min_month,
                    max_month = self.max_month,
                    html = "";

                if (this._y <= min_year) {
                    this.y = min_year;
                    if (!isNaN(min_month) && this._m < min_month) {
                        this._m = min_month;
                    }
                }

                if (this._y >= max_year) {
                    this._y = max_year;

                    if (!isNaN(max_month) && this._m > max_month) {
                        this._m = max_month;
                    }
                }

                for (var c = 0; c < opts.number_of_months; c++) {
                    html += self.renderNavigationSection(opts) + self.renderSwitcherSection(opts) + self.renderMonth(opts);
                }

                return html;
            },

            renderMonth: function (opts) {
                var self = this,
                    now = new Date(),
                    days = self.getDaysInMonth(opts.year, opts.month),
                    before = new Date(opts.year, opts.month, 1).getDay(),
                    current_date = angular.copy(opts.date),
                    data = [],
                    row = [];

                now = self.setToStartOfDay(now);

                if (opts.first_day > 0) {
                    before -= opts.first_day;
                    if (before < 0) {
                        before += 7;
                    }
                }

                var cells = days + before,
                    after = cells;

                while (after > 7) {
                    after -= 7;
                }
                cells += 7 - after;

                for (var i = 0, r = 0; i < cells; i++) {
                    var day = new Date(opts.year, opts.month, 1 + (i - before), opts.date.getHours(), opts.date.getMinutes()),
                        day_start = new Date(opts.year, opts.month, 1 + (i - before)),
                        minComparison = new Date(day_start);

                    if (opts.timeOptions) {
                        minComparison.setHours(23);
                        minComparison.setMinutes(59);
                        minComparison.setSeconds(59);
                    }

                    var is_disabled = (opts.min_date && minComparison < opts.min_date) || (opts.max_date && day_start > opts.max_date),
                        is_selected = self.isDate(current_date) ? self.compareDates(day, current_date) : false,
                        is_today = self.compareDates(day_start, now),
                        is_empty = i < before || i >= days + before;

                    row.push(self.renderDay(1 + (i - before), opts.month, opts.year, is_selected, is_today, is_disabled, is_empty));

                    if (++r === 7) {
                        if (self.showWeekNumber) {
                            row.unshift(self.renderWeek(i - before, opts.month, opts.year));
                        }
                        data.push(self.renderWeek(row, opts.isRTL));
                        row = [];
                        r = 0;
                    }
                }

                return self.renderTable(opts, data);
            },

            renderNavigationSection: function (opts) {
                var self = this,
                    html = '<div class="navigation-section">',
                    isMinYear = opts.year === opts.min_year,
                    isMaxYear = opts.year === opts.max_year,
                    prev = true,
                    next = true;

                if (isMinYear && (opts.month === 0 || self.min_month >= opts.month)) {
                    prev = false;
                }

                if (isMaxYear && (opts.month === 11 || self.max_month <= opts.month)) {
                    next = false;
                }

                html +=
                    '<button tabindex="-1" class="picker-prev prev' +
                    (prev ? "" : " is-disabled") +
                    '" type="button"><span class="icon-thin-arrow-left picker-prev"></span></button>';
                html += '<div class="today-wrapper"><button tabindex="-1" class="picker-today today">' + self.i18n.today + "</button></div>";
                html +=
                    '<button tabindex="-1" class="picker-next next' +
                    (next ? "" : " is-disabled") +
                    '" type="button"><span class="icon-thin-arrow-right picker-next"></span></button>';
                html += "</div>";

                return html;
            },

            renderSwitcherSection: function (opts) {
                let arr = [];
                let i = 0;
                let j = 0;
                let html = '<div class="switchers-section">';
                let month_html = "";
                let year_html = "";
                const self = this;

                // get month <select>
                for (i = 0; i < 12; i++) {
                    arr.push('<option value="' + i + '"' + (i === opts.month ? " selected" : "") + ">" + self.i18n.months[i].full + "</option>");
                }

                month_html =
                    '<div class="picker-label">' +
                    self.i18n.months[opts.month].full +
                    '<select tabindex="-1" class="picker-select picker-select-month">' +
                    arr.join("") +
                    "</select></div>";

                if (self.isArray(opts.year_range)) {
                    i = opts.year_range[0];
                    j = opts.year_range[1] + 1;
                } else {
                    i = opts.year - opts.year_range;
                    j = 1 + opts.year + opts.year_range;
                }

                // get year <select>
                for (arr = []; i < j && i <= self.max_year; i++) {
                    if (i >= self.min_year) {
                        arr.push('<option value="' + i + '"' + (i === opts.year ? " selected" : "") + ">" + i + "</option>");
                    }
                }

                year_html =
                    '<div class="picker-label">' +
                    opts.year +
                    '<select tabindex="-1" class="picker-select picker-select-year">' +
                    arr.join("") +
                    "</select></div>";

                html += month_html + year_html;

                return html + "</div>";
            },

            renderWeek: function (days) {
                return "<tr>" + (this.isRTL ? days.reverse() : days).join("") + "</tr>";
            },

            renderDayName: function (day, abbr) {
                return abbr ? this.i18n.weekdays[day].tiny : this.i18n.weekdays[day].full;
            },

            renderDay: function (d, m, y, is_selected, is_today, is_disabled, is_empty) {
                if (is_empty) {
                    return '<td class="is-empty"></td>';
                }

                var arr = [];

                if (is_disabled) {
                    arr.push("is-disabled");
                }
                if (is_today) {
                    arr.push("is-today");
                }
                if (is_selected) {
                    arr.push("is-selected");
                }

                return (
                    '<td data-day="' +
                    d +
                    '" class="' +
                    arr.join(" ") +
                    '">' +
                    '<button class="picker-btn" type="button" tabindex="-1" ' +
                    'data-picker-year="' +
                    y +
                    '"' +
                    'data-picker-month="' +
                    m +
                    '"' +
                    'data-picker-day="' +
                    d +
                    '">' +
                    d +
                    "</button></td>"
                );
            },

            renderHead: function (opts) {
                var i,
                    self = this,
                    arr = [];

                if (opts.showWeekNumber) {
                    arr.push("<th></th>");
                }

                for (i = 0; i < 7; i++) {
                    arr.push('<th><abbr title="' + self.renderDayName(i) + '">' + self.renderDayName(i, true) + "</abbr></th>");
                }

                return "<thead>" + (opts.isRTL ? arr.reverse() : arr).join("") + "</thead>";
            },
            renderBody: function (rows) {
                return "<tbody>" + rows.join("") + "</tbody>";
            },

            renderTable: function (opts, data) {
                return '<table cellpadding="0" cellspacing="0" class="days-section">' + this.renderHead(opts) + this.renderBody(data) + "</table>";
            }
        };

        /*
         * Date Format 1.2.3
         * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
         * MIT license
         *
         * Includes enhancements by Scott Trenda <scott.trenda.net>
         * and Kris Kowal <cixar.com/~kris.kowal/>
         *
         * Accepts a date, a mask, or a date and a mask.
         * Returns a formatted version of the given date.
         * The date defaults to the current date/time.
         * The mask defaults to dateFormat.masks.default.
         */
        var dateFormat = (function () {
            var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
                timezone =
                    /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
                timezoneClip = /[^-+\dA-Z]/g,
                pad = function (val, len) {
                    val = String(val);
                    len = len || 2;
                    while (val.length < len) {
                        val = "0" + val;
                    }
                    return val;
                };

            // Regexes and supporting functions are cached through closure
            return function (date, mask, utc) {
                var dF = dateFormat;

                // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
                if (arguments.length === 1 && Object.prototype.toString.call(date) === "[object String]" && !/\d/.test(date)) {
                    mask = date;
                    date = undefined;
                }

                // Passing date through Date applies Date.parse, if necessary
                date = date ? new Date(date) : new Date();
                if (isNaN(date)) {
                    throw SyntaxError("invalid date");
                }

                mask = String(dF.masks[mask] || mask || dF.masks["default"]);

                // Allow setting the utc argument via the mask
                if (mask.slice(0, 4) === "UTC:") {
                    mask = mask.slice(4);
                    utc = true;
                }

                var _ = utc ? "getUTC" : "get",
                    d = date[_ + "Date"](),
                    D = date[_ + "Day"](),
                    m = date[_ + "Month"](),
                    y = date[_ + "FullYear"](),
                    H = date[_ + "Hours"](),
                    M = date[_ + "Minutes"](),
                    s = date[_ + "Seconds"](),
                    L = date[_ + "Milliseconds"](),
                    o = utc ? 0 : date.getTimezoneOffset(),
                    flags = {
                        d: d,
                        dd: pad(d),
                        // tslint:disable-next-line:triple-equals
                        ddd: dF.i18n.dayNames[D != 0 ? D - 1 : 6].short,
                        // tslint:disable-next-line:triple-equals
                        dddd: dF.i18n.dayNames[D != 0 ? D - 1 : 6].full,
                        m: m + 1,
                        mm: pad(m + 1),
                        mmm: dF.i18n.monthNames[m].short,
                        mmmm: dF.i18n.monthNames[m].full,
                        yy: String(y).slice(2),
                        yyyy: y,
                        h: H % 12 || 12,
                        hh: pad(H % 12 || 12),
                        H: H,
                        HH: pad(H),
                        M: M,
                        MM: pad(M),
                        s: s,
                        ss: pad(s),
                        l: pad(L, 3),
                        L: pad(L > 99 ? Math.round(L / 10) : L),
                        t: H < 12 ? "a" : "p",
                        tt: H < 12 ? "am" : "pm",
                        T: H < 12 ? "A" : "P",
                        TT: H < 12 ? "AM" : "PM",
                        Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
                        o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + (Math.abs(o) % 60), 4),
                        // tslint:disable-next-line:triple-equals
                        S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (((d % 100) - (d % 10) != 10) * d) % 10]
                    };

                return mask.replace(token, function ($0) {
                    return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
                });
            };
        })();

        // Some common format strings
        dateFormat.masks = {
            default: "ddd mmm dd yyyy HH:MM:ss",
            shortDate: "m/d/yy",
            mediumDate: "mmm d, yyyy",
            longDate: "mmmm d, yyyy",
            fullDate: "dddd, mmmm d, yyyy",
            shortTime: "h:MM TT",
            mediumTime: "h:MM:ss TT",
            longTime: "h:MM:ss TT Z",
            isoDate: "yyyy-mm-dd",
            isoTime: "HH:MM:ss",
            isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
            isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
        };

        // Internationalization strings
        dateFormat.i18n = {
            dayNames: datePickerHelper.i18n.weekdays,
            monthNames: datePickerHelper.i18n.months
        };

        // For convenience...
        Date.prototype.format = function (mask, utc) {
            return dateFormat(this, mask, utc);
        };

        Date.parseDate = function (str, format) {
            var date_regex = /[-\/.\s]/g,
                parts = str.split(date_regex),
                date;

            // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
            switch (format) {
                case "B":
                    //String format is year/month/day
                    date = new Date(convertPartialYear(parts[0]), parts[1] - 1, parts[2]); // Note: months are 0-based
                    break;
                case "M":
                    //String format is month/day/year
                    date = new Date(convertPartialYear(parts[2]), parts[0] - 1, parts[1]); // Note: months are 0-based
                    break;
                default:
                    // String format is day/month/year
                    date = new Date(convertPartialYear(parts[2]), parts[1] - 1, parts[0]); // Note: months are 0-based
            }

            return date;
        };

        /**
         * Merge the year value to the current century / millennium. Conversion examples:
         *  1 (01/10/1) converts to 01/10/2001
         *  01 (01/10/01) converts to 01/10/2001
         *  11 (01/10/11) converts to 01/10/2011
         *  011 (01/10/011) converts to 01/10/2011
         *  2011 (01/10/2011) converts to 01/10/2011
         * Given the current year is 10003, the year stripped from 01/10/1 would convert to 01/10/10001, if getFullYear supported a year greater than 9999
         * @param {string} year
         * @returns {string}
         */
        function convertPartialYear(year) {
            var fullYear = new Date().getFullYear();
            var yearLength = year.length;

            if (yearLength < fullYear.toString().length) {
                if (parseInt(year, 10) > 49 && fullYear % 100 < 50) {
                    fullYear -= 100;
                }

                return ((fullYear / Math.pow(10, yearLength === 1 ? 2 : yearLength)) << 0).toString() + year;
            }

            return year;
        }

        return datePickerHelper;
    }
]);
